const btnClass = 'btn';
const activeClass = 'is--active';

// Meta Navigation
const metaNavigation = document.getElementById('metaNavigation');

if (metaNavigation !== null) {
  metaNavigation.addEventListener('click', (event) => {
    const target = event.target;

    if (!target.classList.contains('shownav')) {
      document.body.classList.remove('open-off-canvas');
      document.querySelector('.main-navigation').classList.remove('is--open');
      document.querySelector('.btn.shownav').classList.remove('is--active');
    }

    if (target.nodeName === 'BUTTON' && target.classList.contains(btnClass)) {
      target.classList.toggle(activeClass);
    }
  });
}



// WEBPACK FOOTER //
// ./assets/js/components/buttons.js